import React from 'react';
import { Download, Headphones, Share2 } from 'lucide-react';
export function HowItWorks() {
  return <section className="bg-white py-16 px-4 border-y border-gray-200" data-id="element-241">
      <div className="max-w-4xl mx-auto" data-id="element-242">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-navy mb-12" data-id="element-243">
          How It Works
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-244">
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gray-200 z-0" data-id="element-245"></div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-246">
            <div className="w-24 h-24 bg-navy rounded-full flex items-center justify-center text-white mb-6 shadow-lg border-4 border-white" data-id="element-247">
              <Download size={36} data-id="element-248" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-2" data-id="element-249">
              1. Instant Access
            </h3>
            <p className="text-gray-600" data-id="element-250">
              Secure your bundle and receive a download link immediately via
              email.
            </p>
          </div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-251">
            <div className="w-24 h-24 bg-patriot-red rounded-full flex items-center justify-center text-white mb-6 shadow-lg border-4 border-white" data-id="element-252">
              <Headphones size={36} data-id="element-253" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-2" data-id="element-254">
              2. Listen & Read
            </h3>
            <p className="text-gray-600" data-id="element-255">
              Experience the audiobook and dive into the digital bonus books on
              any device.
            </p>
          </div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-256">
            <div className="w-24 h-24 bg-gold rounded-full flex items-center justify-center text-navy mb-6 shadow-lg border-4 border-white" data-id="element-257">
              <Share2 size={36} data-id="element-258" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-2" data-id="element-259">
              3. Keep & Share
            </h3>
            <p className="text-gray-600" data-id="element-260">
              Save it to your phone, share it with family, and revisit the
              quotes and timeline anytime.
            </p>
          </div>
        </div>
      </div>
    </section>;
}